import { render, staticRenderFns } from "./Jiankang.vue?vue&type=template&id=627b52df&scoped=true&"
import script from "./Jiankang.vue?vue&type=script&lang=ts&"
export * from "./Jiankang.vue?vue&type=script&lang=ts&"
import style0 from "./Jiankang.vue?vue&type=style&index=0&id=627b52df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b52df",
  null
  
)

export default component.exports